export default "__VITE_ASSET__BnlV9BpP__"